import React from 'react';
import clsx from 'clsx';
import { FormattedMessage } from 'react-intl';
import { List } from 'semantic-ui-react';
import ValidationSpan from './ValidationSpan';

const ListValidationError = ({
  error,
  position = 'right',
  labelText,
  labelId,
}) => (
  <List.Header className={clsx(error && 'aridhia-is-edit-mode-validation-highlight')}>
    {labelId && (<FormattedMessage id={labelId} />)}
    {labelText}
    <ValidationSpan validationError={error} position={position} />
  </List.Header>
);

export default ListValidationError;
